export default __webpack_public_path__ + "static/media/17-1.647736c6.jpg";